export const makeOrderNumber = (cryptoObject, now = Date.now) => {
  const secureCrypto = cryptoObject || (typeof window !== "undefined" ? window.crypto : null);
  if (secureCrypto?.randomUUID) return `ITV-${secureCrypto.randomUUID()}`;
  const random = Math.random().toString(36).slice(2, 12).toUpperCase();
  return `ITV-${now()}-${random}`;
};

export const buildPaymentUrl = ({
  orderNo,
  amount,
  currency,
  email,
  title,
  origin,
}) => {
  const params = new URLSearchParams({
    orderNo,
    amount: Number(amount).toFixed(2),
    currency,
    email: email.trim(),
    success_url: `${origin}/payment?state=success`,
    cancel_url: `${origin}/payment?state=cancel`,
    title,
  });

  return `/create_payment.php?${params.toString()}`;
};
